<div class="minimize-map-with-sidebar-button">
    <ui-map-button>
        <ui-icon
            aria-hidden
            [icon]="'window-minimize'"
        />
    </ui-map-button>
</div>
